import { render, staticRenderFns } from "./BaseAutocomplete.vue?vue&type=template&id=4f03d9ba"
import script from "./BaseAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./BaseAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports